import { inject, Injectable, signal } from '@angular/core';

import type { AutocompleteResult, StockTreeFilters, StockTreeNode } from '../inventory/models/inventory.model';
import { InventoryService } from '../inventory/inventory.service';

@Injectable()
export class StockStore {
  private readonly inventoryService = inject(InventoryService);

  readonly tree = signal<StockTreeNode[]>([]);
  readonly suggestions = signal<AutocompleteResult[]>([]);
  readonly loading = signal(false);
  readonly error = signal<string | null>(null);

  loadTree(filters?: StockTreeFilters): void {
    this.loading.set(true);
    this.error.set(null);

    this.inventoryService.getStockTree(filters).subscribe({
      next: (response) => {
        this.tree.set(response.data);
        this.loading.set(false);
      },
      error: (error: unknown) => {
        this.error.set(resolveErrorMessage(error));
        this.loading.set(false);
      }
    });
  }

  autocomplete(query: string, storeId?: string): void {
    const trimmed = query.trim();

    if (trimmed.length < 3) {
      this.suggestions.set([]);
      return;
    }

    this.inventoryService.getStockAutocomplete(trimmed, storeId).subscribe({
      next: (response) => {
        this.suggestions.set(response.data);
      },
      error: () => {
        this.suggestions.set([]);
      }
    });
  }
}

const resolveErrorMessage = (error: unknown): string => {
  if (error instanceof Error && error.message) {
    return error.message;
  }

  return 'No pudimos cargar la vista de stock.';
};
